// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyC1vsl9lQQBXaDpNmE7EAmFV9Y5q65t7kE",
    authDomain: "my-angular-site.firebaseapp.com",
    databaseURL: "https://my-angular-site.firebaseio.com",
    projectId: "my-angular-site",
    storageBucket: "my-angular-site.appspot.com",
    messagingSenderId: "194975598566",
    appId: "1:194975598566:web:11c5caa358241c6221b827"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
